import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError, handleAlertBoxClick } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import Modal from 'react-bootstrap/Modal';
const initialFieldValues = {
    userTemplateId: "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    subject: "",
    content: ""
};
export default function UserTemplates() {
    const [lists, setLists] = useState([]);
    const [values, setValues] = useState(initialFieldValues);
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [errors, setErrors] = useState({});
    const [btnSubmit, setBtnSubmit] = useState(true);
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => {
        setAddShow(false);
        setRecordForEdit(null);
        setValues(initialFieldValues);
    };

    const handleAddShow = () => {
        setRecordForEdit(null);
        setValues(initialFieldValues);
        setAddShow(true);
    };
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    useEffect(() => {
        if (recordForEdit !== null) {
            setValues(recordForEdit);
        }
    }, [recordForEdit]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };
    const validate = () => {
        let temp = {};
        temp.subject = values.subject === "" ? false : true;
        temp.content = values.content === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnSubmit(false);
            var formData = {
                "userTemplateId": values.userTemplateId,
                "userId": localStorage.getItem("userId"),
                "subject": values.subject,
                "content": values.content
            }
            addOrEdit(formData);
        }
    };
    const applicationAPI = () => {
        return {
            create: (newrecord) =>
                axios.post(config.APIACTIVATEURL + config.CREATEUSERTEMPLATE, newrecord, { ...headerconfig }),
            update: (updateRecord) =>
                axios.put(config.APIACTIVATEURL + config.UPDATEUSERTEMPLATE, updateRecord, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        if (formData.userTemplateId === "00000000-0000-0000-0000-000000000000") {
            applicationAPI()
                .create(formData)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Record Created");
                        resetForm();
                        GetData();
                        setBtnSubmit(true);
                    }
                    else {
                        handleError(res.data.data);
                        setBtnSubmit(true);
                    }
                })
                .catch(function (error) {
                    handleError("Error in saving data");
                    setBtnSubmit(true);
                });
        } else {
            applicationAPI()
                .update(formData)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Record Updated");
                        resetForm();
                        GetData();
                        setBtnSubmit(true);
                    }
                    else {
                        handleError(res.data.message);
                        setBtnSubmit(true);
                    }
                })
                .catch(function (error) {
                    handleError("Error in updating data");
                    setBtnSubmit(true);
                });
        }
    };
    const resetForm = () => {
        setValues(initialFieldValues);
        setErrors({});
        handleAddClose();
    };
    const showEditDetails = (data) => {
        setRecordForEdit(data);
        setValues(data);
        setAddShow(true);
    };
    const onDelete = (e, id) => {
        if (window.confirm('Are you sure to delete this record?')) {
            axios.delete(config.APIACTIVATEURL + config.DELETEUSERTEMPLATE + "/" + id, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetData();
                        resetForm();
                    }
                    else {
                        handleError(response.data.message);
                        GetData();
                    }
                });
        }
    }
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETUSERTEMPLATES + "?UserId=" + localStorage.getItem("userId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLists(response.data.data?.data);
                }
            });
    };
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        GetData();
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="card card-body py-3">
                        <div className="d-flex justify-content-between">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-2">Templates</h4>
                            </div>
                            <button type="button" className="btn btn-primary add-btn" onClick={handleAddShow}>
                                <i className="ri-add-line align-bottom me-1" /> Add Template
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        {lists.length > 0 && lists.map((v, index) =>
                            <div className="col-4">
                                <div class="card">
                                    <div className="card-header bg-info">Subject : {v.subject}</div>
                                    <div className="card-body" style={{minHeight:"300px"}}>Content : {v.content}</div>
                                    <div className="card-footer bg-dark">
                                        <div className="d-flex justify-content-between">
                                            <button type="button" className="btn btn-secondary btn-sm" onClick={e => showEditDetails(v)}>
                                                <i className="ri-pencil-fill align-bottom me-1" /> Edit
                                            </button>
                                            <button type="button" className="btn btn-danger btn-sm" onClick={e => onDelete(e, v.userTemplateId)}>
                                                <i className="ri-delete-bin-line align-bottom me-1" /> Delete
                                            </button>
                                            {/* <Link to={"/"} target="_blank" className="btn btn-info btn-sm" onClick={e => onDelete(e, v.userTemplateId)}>
                                                <i className="ri-eye-line align-bottom me-1" /> Preview
                                            </Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Modal size="lg" show={addShow} onHide={handleAddClose} onExited={() => { setRecordForEdit(null); setValues(initialFieldValues); }}>
                    <Modal.Header>
                        <Modal.Title>{values.userTemplateId === "00000000-0000-0000-0000-000000000000" ? "Add" : "Edit"} Template</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                            <div className="row">
                                <div className="col-lg-12 mb-3">
                                    <label htmlFor="subject" className="form-label">Email Subject</label>
                                    <input type="text" value={values.subject} name="subject" onChange={handleInputChange} className={"form-control" + applyErrorClass('subject')} placeholder="Ex: Please verify documents and process the loan" />
                                    {errors.subject === false ? (<div className="validationerror">Please enter subject </div>) : ('')}
                                </div>
                                <div className="col-lg-12 mb-3">
                                    <label htmlFor="content" className="form-label">Email Content</label>
                                    <textarea type="text" value={values.content} name="content" onChange={handleInputChange} className={"form-control" + applyErrorClass('content')} placeholder="Please verify documents and process the loan" style={{ minHeight: "300px" }} />
                                    {errors.content === false ? (<div className="validationerror">Please enter content </div>) : ('')}
                                </div>
                                <Modal.Footer>
                                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                        {
                                            btnSubmit === true ?
                                                <button type="submit" className="btn btn-primary">{values.userTemplateId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update"}</button>
                                                :
                                                <button type="submit" className="btn btn-primary" disabled>Please wait...</button>
                                        }
                                        <button type="button" className="btn btn-danger" onClick={resetForm}>Cancel</button>
                                    </div>
                                </Modal.Footer>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
}